import { EventModel } from '@bryntum/calendar/calendar.umd';

export default class Event extends EventModel {
    static get fields() {

        return [
            { name: 'credit', type: 'number' },
            { name: 'creditType' },
            { name: 'inscription' },
            { name: 'lessonType' },
            { name: 'splitDuration' },
            'parite',
            'room',
            'reservation'
            //'image',
            //'important',
            //'nbrAttachments'
        ];
    }

    static get defaults() {
        return {
            credit: null
        };
    }
}